import { render } from "./PayorTable.vue?vue&type=template&id=2d42da7c&ts=true"
import script from "./PayorTable.ts?vue&type=script&lang=ts&external"
export * from "./PayorTable.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__